/*
 * Vehicle steps, one refresh pass for a <seatfit-vehicle-steps> element (el):
 * rules -> view -> the product's hidden option radios (seatfit-vehicle-steps-options.js) -> hidden cart
 * inputs -> Buy button -> URL -> page name -> 'seatfit:selection'. The element keeps the state (kind, ctx,
 * picks, setPicked, open ...); these functions read it, so the element file only deals with events and loading.
 */
(function () {
  'use strict';
  if (window.SeatFitStepsSync) return;
  var M = window.SeatFitStepsModel;
  var V = window.SeatFitStepsView;
  var B = window.SeatFitShrine;
  var P = window.SeatFitStepsPage;
  var O = window.SeatFitStepsOptions;

  // Shrine always has a Seat Set radio checked (Front Seats on load, matching the reference price), so the
  // set only counts once the shopper picked a card or the link carried ?set=. A cover's colour is the checked
  // swatch: with the vehicle row it decides the price tier.
  function rulePicks(el) {
    var p = el.picks || {};
    var out = { gen: p.gen, set: el.setPicked ? p.set : null, seat: p.seat };
    ((window.SeatFit && window.SeatFit.STEP_PARAMS) || []).forEach(function (k) { out[k] = p[k]; });
    if (el.kind === 'cover' && el.shop) out.color = B.checked(el.shop, el.shop.colorName);
    return out;
  }

  function state(el) {
    return { ctx: el.loading ? null : el.ctx, sel: el.sel, s: el.s, years: el.years, images: el.images || {},
      open: el.open, revealRear: el.revealRear, loading: el.loading, raw: el.raw || {}, shop: el.shop };
  }

  function update(el, byShopper, raw) {
    try {
      var sf = window.SeatFit;
      if (raw) el.raw = raw;
      var ctx = el.loading ? null : el.ctx;
      var picks = rulePicks(el);
      el.sel = ctx && ctx.status === 'ok' && sf && sf.stepsFor ? sf.stepsFor(ctx, picks) : null;
      // A cover colour the chosen row does not sell was just swapped for one it sells: read the rules again.
      if (O.fixColor(el, picks)) el.sel = sf.stepsFor(ctx, picks);
      el.complete = !!(el.sel && el.sel.complete);
      var st = state(el);
      el.vm = M.build(st);
      V.render(el.body, el.vm, el.s);
      // The data sells something this product has no variant for: never add a different one to the cart.
      if (!O.select(el)) el.complete = false;
      B.writeInputs(el.inputsBox, el.shop, el.complete ? sf.cartProperties(ctx, el.sel.row, picks) : null);
      paint(el);
      if (byShopper) writeUrl(el);
      if (el.loading) return;
      P.apply(st);
      if (sf && sf.emit) {
        sf.emit('selection', { ctx: ctx, row: (el.sel && el.sel.row) || null, picks: picks, complete: el.complete,
          kind: el.kind });
      }
    } catch (e) {
      console.warn('[SeatFit] vehicle steps refresh failed', e);
    }
  }

  function paint(el) {
    try {
      if (!el.shop) return;
      var text = el.vm && el.ctx && !el.loading ? M.buttonLabel(state(el), el.vm) : null;
      B.paintButton(el.shop, { locked: !el.complete, text: text, done: M.completeLabel(el.s, el.shipDay) });
    } catch (e) {
      console.warn('[SeatFit] could not relabel the Buy button', e);
    }
  }

  // Our params + Shrine's variant, colour and style; every other param (utm_*, fbclid) is kept by core.
  function writeUrl(el) {
    var sf = window.SeatFit;
    if (!sf || !el.shop) return;
    var p = M.urlParams(el.loading ? null : el.ctx, el.sel) || {};
    var cur = B.current(el.shop);
    if (cur.variant) p.variant = cur.variant;
    if (cur.color) p.color = cur.color;
    if (cur.style) p.style = cur.style;
    sf.writeParams(p);
  }

  // Runs after Shrine's own change handler. A shopper's colour click moves a cover to another price tier, so the
  // whole pass runs and Size, cart fields and link follow; our own radio clicks (el.syncing) and every other
  // change only rewrite the link and the button.
  function afterVariant(el) {
    if (el.kind === 'cover' && !el.syncing) return update(el, true);
    writeUrl(el);
    paint(el);
  }

  // Buy clicked too early: no vehicle -> the message button (picker or retry); else scroll to the
  // missing step, open it and flash it, like the reference "Step 2: Select Body" button does.
  function jump(el) {
    var vm = el.vm;
    if (!vm || vm.kind === 'loading') return;
    if (vm.kind === 'message') {
      var btn = el.body.querySelector('.sf-msg__btn');
      if (btn) btn.click();
      return;
    }
    var key = vm.missing ? vm.missing.key : null;
    var row = key ? el.body.querySelector('[data-sf-step="' + key + '"]') : null;
    if (!row) return;
    // A seat type row lives inside the Seat Set step: if the shopper folded that step, the row is
    // hidden and scrolling/focusing it would do nothing, so reopen the step that holds it.
    var step = row.classList.contains('sf-step') ? row : row.closest('.sf-step');
    var stepKey = step && step.getAttribute('data-sf-step');
    if (step && stepKey !== 'year' && !step.classList.contains('is-open')) {
      el.open[stepKey] = true;
      step.classList.add('is-open');
      var head = step.querySelector('.sf-step__head[aria-expanded]');
      if (head) head.setAttribute('aria-expanded', 'true');
    }
    try { row.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { row.scrollIntoView(); }
    row.classList.remove('sf-is-flash');
    void row.offsetWidth; // restart the animation on a second click
    row.classList.add('sf-is-flash');
    var focusable = row.querySelector('select, button[data-sf-act]:not([data-sf-act="toggle"])');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  window.SeatFitStepsSync = { update: update, paint: paint, writeUrl: writeUrl, afterVariant: afterVariant, jump: jump };
})();
